import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cssType' })
export class CssTypePipe implements PipeTransform {
    transform(value: any, type?: string) {
        let cssFile = '';
        const path = '/assets/css/editor-skins/';
        switch (type) {
            case 'Red':
                cssFile = path + 'red.css';
                break;
            case 'Yellow':
                cssFile = path + 'yellow.css';
                break;
            case 'Blue':
                cssFile = path + 'blue.css';
                break;
            default:
                cssFile = 'dark';
                break;
        }

        return {
            base_url: '/tinymce',
            content_css: ['/assets/css/editor-skins/base.css/', cssFile],
            suffix: '.min',
            height: 150,
            menubar: false,
            toolbar: false,
            statusbar: false,
            plugins: ['advlist lists link', 'visualblocks', 'paste code help'],
        };
    }
}
